import React, { useState, useEffect } from 'react';
import TextLoop from "react-text-loop";
import { trackEvent } from "../../services/analytics";
import {Navbar, Nav, Image, NavDropdown} from 'react-bootstrap'
import { useTranslation } from 'react-i18next';
import LandingPageNav from "../../components/navbars/landingPage";
import FooterLandingPage from "../../components/footers/landing";
import Section from "../../components/landingPage/sections";
import {Helmet} from "react-helmet";

const Fulfillment = (props) => {
    const [ lang, setLang ] = useState('en');
    const [ loading, setLoading ] = useState(true);
    const { t, i18n } = useTranslation();

    useEffect(()=> {
        const lang = props.match.params.lang || localStorage.getItem('language');
        setLang(lang);
        setLoading(false);
        i18n.changeLanguage(lang)
        localStorage.setItem('language', lang);
    },[]);

    const onClickSignIn = (name) => {
        trackEvent('Click',{
            action: "track",
            category: "Buttons",
            label: name,
            event: "Click"
        })
    };

    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Fulfillment Service</title>
                <meta name="description" content="Layanan pick and pack. Memudahkan menjalankan bisnis tanpa harus mengurus operasional sehari-hari." />
                <link rel="canonical" href="https://biteship.com/fulfillment" />
            </Helmet>
            <LandingPageNav/>

            <section className="slice slice-lg">
                <div className="container">
                    <div className="mb-5 mt-5">
                        <h1 className="lh-150">
                            <strong>
                                Layanan Fulfillment
                            </strong>
                        </h1>
                        <h2 className='text-primary'>
                            <strong>
                                Layanan manajemen gudang 
                            </strong>                           
                        </h2>
                        <text className='lead text-dark'>
                            <strong>in partnership dengan Gudang.io</strong>
                        </text>
                        <div className="mt-3">
                            <p className="lead lh-180">
                                Layanan pergudangan mulai dari sewa harian storage hingga proses pengemasan untuk penjualan toko online Anda.
                            </p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-4 mb-3">
                            <div className="card hover-translate-y-n10 hover-shadow-lg p-2">
                                <div className="card-body">
                                    <div className="">
                                        <div className="pb-3">
                                            <div
                                                className="icon bg-primary text-white rounded-circle icon-lg icon-shape shadow">
                                                <i className="fas fa-warehouse"></i>
                                            </div>
                                        </div>
                                        <h2 className="font-weight-bold">Penyimpanan.</h2>
                                        <p className="mt-2">Simpan barang Anda di Gudang kami</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 mb-3">
                            <div className="card hover-translate-y-n10 hover-shadow-lg p-2">
                                <div className="card-body">
                                    <div className="">
                                        <div className="pb-3">
                                            <div
                                                className="icon bg-primary text-white rounded-circle icon-lg icon-shape shadow">
                                                <i className="fas fa-box"></i>
                                            </div>
                                        </div>
                                        <h2 className="font-weight-bold">Pick and Pack.</h2>
                                        <p className="mt-2">Kami akan bantu mengemas barang Anda</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 mb-3">
                            <div className="card hover-translate-y-n10 hover-shadow-lg p-2">
                                <div className="card-body">
                                    <div className="">
                                        <div className="pb-3">
                                            <div
                                                className="icon bg-primary text-white rounded-circle icon-lg icon-shape shadow">
                                                <i className="fas fa-truck"></i>
                                            </div>
                                        </div>
                                        <h2 className="font-weight-bold">Pengiriman.</h2>
                                        <p className="mt-2">Kami akan mengirimkan barang Anda.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="slice">
                <div className=' container'>
                    <h2>
                        <strong>
                            Kami bantu proses pengemasan barang Anda
                        </strong>
                        <p className='lead mt-2'>
                            Biteship bekerjasama dengan Gudang.io untuk mempermudah bisnis Anda dalam penyimpanan, manajemen inventori, pengemasan dan monitoring stok.                       
                        </p>
                    </h2>

                    <h3 className='text-tiffany-900 mt-4'>
                        <strong>
                            Kami dapat proses pengemasan dari berbagai channel penjualan                         
                        </strong>
                    </h3>
                    <div className='row align-items-center text-center mt-4'>
                        <div className='col-3 pr-4 pl-4'>
                            <img alt="Biteship Shipment" style={{height:60}} src="/images/landing/biteship-tiktok.png" className="img-fluid"/>
                        </div>
                        <div className='col-3 pr-4 pl-4'>
                            <img alt="Biteship Shipment" style={{height:60}} src="/images/landing/biteship-jd.png" className="img-fluid"/>
                        </div>
                        <div className='col-3 pr-4 pl-4'>
                            <img alt="Biteship Shipment" style={{height:60}} src="/images/landing/biteship-shopee.png" className="img-fluid"/>
                        </div>
                        <div className='col-3 pr-4 pl-4'>
                            <img alt="Biteship Shipment" style={{height:60}} src="/images/landing/biteship-tokopedia.png" className="img-fluid"/>
                        </div>
                    </div>

                    <div className='row align-items-center text-center mt-4'>
                        <div className='col-3 pr-4 pl-4'>
                            <img alt="Biteship Shipment" style={{height:60}} src="/images/landing/biteship-bukalapak.png" className="img-fluid"/>
                        </div>
                        <div className='col-3 pr-4 pl-4'>
                            <img alt="Biteship Shipment" style={{height:60}} src="/images/landing/biteship-lazada.png" className="img-fluid"/>
                        </div>
                        <div className='col-3 pr-4 pl-4'>
                            <img alt="Biteship Shipment" style={{height:48}} src="/images/landing/biteship-blibli.png" className="img-fluid"/>
                        </div>
                        <div className='col-3 pr-4 pl-4'>
                            <img alt="Biteship Shipment" style={{height:60}} src="/images/landing/biteship-zalora.png" className="img-fluid"/>
                        </div>
                    </div>
                    
                    <a href="https://s.id/biteship-web-fulfillment-sales-section" onClick={() => onClickSignIn('Sign In Main Header')}>
                        <button className="btn btn-secondary mt-5 border" >
                            Kontak Sales Fulfillment
                        </button>
                    </a>
                    <a href="/pricing" onClick={() => onClickSignIn('Sign In Main Header')}>
                        <button className="btn btn-primary mt-5 ml-3 border" >
                            Detail Harga Fulfillment
                        </button>
                    </a>
                    </div>
                    <div style={{height:320}}/>
                </section>

            <Section/>
            <FooterLandingPage/>
        </>
    )
}

export default Fulfillment;
